import { render, staticRenderFns } from "./CLabel.vue?vue&type=template&id=c76464d0&scoped=true&"
import script from "./CLabel.vue?vue&type=script&lang=js&"
export * from "./CLabel.vue?vue&type=script&lang=js&"
import style0 from "./CLabel.vue?vue&type=style&index=0&id=c76464d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76464d0",
  null
  
)

export default component.exports